import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { updateTrcContentApi } from '@/data/api/trc';
import { handleErrorResponse } from '@/utils/handleErrorResponse';
import { buildRoutes } from '@/service/buildRoutes';
import ProduceTRCContent from './components/ProduceTRCContent';
import { useFetchTrcContentById } from '@/data/swrs/trc';
import { API_KEYS, FIELDS, FILE_TYPE, MESSAGES, UI_LABELS } from './components/utils/constants';

const mapRawToInitialValues = (raw = {}) => {
	const fileType = raw?.[FIELDS.FILE_TYPE] ?? FILE_TYPE.VIDEO;
	
	return {
		_id: raw._id,

		[FIELDS.TITLE]: raw?.[FIELDS.TITLE] ?? '',
		[FIELDS.ABOUT]: raw?.[FIELDS.ABOUT] ?? '',
		[FIELDS.DURATION]: raw?.[FIELDS.DURATION] ?? '',
		[FIELDS.PAGES]: raw?.[FIELDS.PAGES] ?? '',
		[FIELDS.THUMBNAIL_LINK]: raw?.[API_KEYS.THUMBNAIL_LINK] ?? '',
		[FIELDS.INSTRUCTOR]: raw?.[FIELDS.INSTRUCTOR] ?? raw?.instructorDetails?.[0]?.name ?? '',
		[FIELDS.TAGS]: Array.isArray(raw?.tagsDetails) ? raw.tagsDetails.map(t => t?.name).filter(Boolean) : [],
		[FIELDS.PRODUCTS]: Array.isArray(raw?.productsData)
			? raw.productsData || []				
		[FIELDS.FILE_TYPE]: fileType,
		[FIELDS.FILE_URL]: raw?.[FIELDS.FILE_URL] ?? '',
		[FIELDS.CATEGORY]: Array.isArray(raw?.categoryDetails)
			? raw.categoryDetails.map(c => (c?._id)).filter(Boolean)
			: [],
		[FIELDS.RELATED]: Array.isArray(raw?.related) ? raw.related.map(item => item?._id).filter(Boolean) : [],
		...raw
	};
};

const EditContent = () => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { data: contentData, error, isLoading, mutate } = useFetchTrcContentById(id);

	const handleUpdate = async payload => {
		const response = await updateTrcContentApi(id, payload);
		if (handleErrorResponse(response)) {
			throw new Error('Update TRC content failed');
		}
		mutate(buildRoutes.toTRCEditContent(id), response.data.data, false);
		navigate(buildRoutes.toTRCContent());
	};
	if (isLoading) return <div>{UI_LABELS.LOADING}</div>;
	if (error) return <div>{error?.message ?? MESSAGES.ERROR_GENERIC}</div>;

	const mappedInitialValues = mapRawToInitialValues(contentData?.data);

	return (
		<ProduceTRCContent
			mode="edit"
			initialValues={mappedInitialValues}
			onSubmit={handleUpdate}
			labels={{
				title: UI_LABELS.PAGE_TITLE_EDIT,
				submit: UI_LABELS.BTN_SAVE,
				reset: UI_LABELS.BTN_RESET,
				successCreate: MESSAGES.SUCCESS_EDIT
			}}
		/>
	);
};

export default EditContent;
